
export default function(){
    
    const initialState = {
        getData:null
    }
    
    return function(state = initialState, action) {
        switch(action.type){
            //
            case "SET_FORM_CONFIG":
                return {
                    ...state,
                    getData: action.getData
                }

            //
            default: return state;
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/form/form-reducer.ts